import React, { useState } from "react";

import Chip from "../../../../components/Chip/Chip";
import InputCheckbox from "../../../../components/InputCheckbox/InputCheckbox";
import InputText from "../../../../components/InputText/InputText";
import { searchSocCodes } from "../../../../services/soc-code.service";

function AddSocCodeOnet({
	socCodeList = [],
	selectedSocCode = [],
	setSelectedSocCode = () => false,
	handleToggleCheckboxSocCode,
	errorSOCValidation,
	setSelectedSOCCodes = () => false,
	dashboardDataSocs,
	selectedSOCCodes,
	socCodes = [],
	setSocCodes = () => false,
}) {
	const [socCodeSearchInputValue, setSocCodeSearchInputValue] = useState("");

	const handleInputChange = (newValue) => {
		setSocCodeSearchInputValue(newValue);
	};

	const handleCheckboxChange = (isChecked, socCodeObj) => {
		const { soc_code, title, id, search_term } = socCodeObj;

		// Always start from the selection the parent currently holds. This way a
		// background re-render can never wipe what was already picked, and each
		// click adds to (or removes from) the live selection instead of replacing it.
		let newSelection;
		if (isChecked) {
			// Add this code only if it isn't already in the selection.
			if (!selectedSocCode.some((item) => item.id === id)) {
				newSelection = [...selectedSocCode, { soc_code, soc_name: title, id, search_term }];
			} else {
				newSelection = selectedSocCode;
			}
		} else {
			// Remove SOC	 code from the selection.
			newSelection = selectedSocCode.filter((item) => item.id !== id);
		}

		const updatedSelectedSocCode = newSelection.map((item) => ({
			id: item.id,
			soc_code: item.soc_code,
			soc_name: item.soc_name,
			name: item.soc_name,
			search_term: item.search_term || "",
		}));

		setSelectedSocCode(updatedSelectedSocCode);
		setSelectedSOCCodes(updatedSelectedSocCode);
	};

	const handleRemoveChip = (socCodeObj) => {
		handleCheckboxChange(false, socCodeObj);
	};

	const fetchSocCodesBySearch = async (title) => {
		const fetchSocCodes = await searchSocCodes({ title });
		if (fetchSocCodes && fetchSocCodes.data && fetchSocCodes.data.soc_codes) {
			setSocCodes(fetchSocCodes.data.soc_codes);
		}
	};

	return (
		<div className='db-state-table-modal-step-item step-three'>
			<div>
				<div>
					<div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
						<InputText
							className={"job-search"}
							type='text'
							value={socCodeSearchInputValue}
							onValueChange={handleInputChange}
							label=''
							placeholder='Search by Job Title'
						/>
						<button
							style={{ minWidth: "auto" }}
							onClick={() => {
								fetchSocCodesBySearch(socCodeSearchInputValue);
							}}
							className='btn primary'
						>
							Search
						</button>
					</div>
					<div className='chip-list'>
						{selectedSocCode.map((item) => (
							<Chip size='28' key={`chip-${item.soc_code}-${item.soc_name}`} dismissible={true}>
								{item.soc_name || item.name}
								<span
									data-id={`${item.name} ${item.soc_code}`}
									className='remove pointer'
									onClick={() => handleRemoveChip(item)}
								>
									&times;
								</span>
							</Chip>
						))}
					</div>
					<div className='card-content modal-body' style={{ overflow: "hidden" }}>
						<div style={{ marginTop: "30px", height: "500px", overflow: "auto" }} className='checkbox-list'>
							{!socCodes.length && "Enter a search term to look up SOC codes by job title"}
							{socCodes.map((socCodeObj, index) => (
								<InputCheckbox
									key={`list-${socCodeObj.soc_code}-${index}`}
									label={socCodeObj.title}
									isChecked={selectedSocCode.some((item) => item.id === socCodeObj.id)}
									onValueChange={(isChecked) => handleCheckboxChange(isChecked, socCodeObj)}
								/>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AddSocCodeOnet;
